// eslint-disable-next-line
export const REGEXP_ID = /^[a-z|0-9|\_\-]{3,20}$/;
export const REGEXP_ID_START = /^[a-z]/g;

// eslint-disable-next-line
export const REGEXP_PASSWORD = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\~\!\@\#\$\%\^\&\*\(\)\+\|\=])[a-zA-Z0-9\~\!\@\#\$\%\^\&\*\(\)\+\|\=]{8,16}$/;

export const REGEXP_EMAIL = /^[a-zA-Z0-9]([-_.]?[a-zA-Z0-9])*@[a-zA-Z0-9]([-_.]?[a-zA-Z0-9])*.[a-zA-Z]{2,3}$/i;

// eslint-disable-next-line
export const REGEXP_SPECIAL = /^[ㄱ-ㅎ|가-힣|ㅏ-ㅣ|a-z|A-Z|0-9|\!\@\&\(\)\-\_\+\[\]\{\}\.\s]*$/;

// 마이너스 포함 숫자만
// export const REGEXP_NUMBER = /^[-]?[0-9]+$/;

// REGEXP_NUMBER + 소수점 한 자리까지만 
export const REGEXP_DECIMAL = /^[-]?[0-9]+(\.{1}[0-9]{0,3})?$/;

export const REGEXP_SERIAL_NUMBER = /^[0-9A-Z]{10}$/;